import React from "react"
import { FaCheck, FaRedo } from "react-icons/fa"
import { WhiteAppButton } from "../../../Buttons/Buttons"
import HeroSection from "./HeroSection"

const CalculatorResetButton: React.FC<{
  onClick: () => void
  readyToReset: boolean
}> = ({ onClick, readyToReset }) => {
  let Icon = <FaCheck />
  if (readyToReset) Icon = <FaRedo />
  return (
    <div>
      <div className="flex justify-center lg:justify-start ">
        <div
          style={{ width: "100px", height: "4px" }}
          className="bg-blue-100 mb-5 rounded-full"
        />
      </div>
      <div className="lg:flex items-center">
        <WhiteAppButton
          className="lg:py-3"
          onClick={onClick}
          title={"Reset Calculator"}
          Icon={Icon}
        />
      </div>
    </div>
  )
}

const CalculatorHeroSection: React.FC<{
  onClick: () => void
  readyToReset: boolean
}> = props => <HeroSection Button={<CalculatorResetButton {...props} />} />

export default CalculatorHeroSection
